<adv-growl></adv-growl>
<p-panel>
  <p-header>
    <label i18n="@@labelText69">Anexos</label>
  </p-header>
  <p-table [value]="anexos"
           [columns]="cols"
           [responsive]="true">

    <ng-template pTemplate="caption">
      <div style="text-align: right">
        <button pButton type="button" i18n-label
                label="Anexar Arquivo" (click)="showAnexarArquivoDialog()"></button>
      </div>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr class="ui-g">
        <th [ngClass]="i < 2 ? 'ui-g-4' : i == 2 ? 'ui-g-3' : 'ui-g-1'" *ngFor="let col of columns ; let i = index">
          <label>{{col.header}}</label>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-anx>
      <tr class="ui-g">
        <td class="ui-g-4">
          {{ anx.nomeArquivo }}
        </td>
        <td class="ui-g-4">
          {{ anx.descricao }}
        </td>
        <td class="ui-g-3" style="text-align: center; vertical-align: middle">
          <label class="iconTable"><label class="fas fa-external-link-alt" (click)="visualizarArquivo(anx)"></label></label>
        </td>
        <td class="ui-g-1" style="text-align: center; vertical-align: middle">
          <a (click)="deletarAnexo(anx)">
            <img src="../../assets/images/delete.png"/>
          </a>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>

